import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sv2-step" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"30px"} }, "Welcome!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "sv2-step__subtitle",
  style: {"margin-top":"8px"}
}, " To begin sharing your screen, enter the Ditto room code displayed in the room. ", -1)
const _hoisted_4 = { style: {"margin-top":"24px"} }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { style: {"margin-top":"16px"} }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "sv2-spinner"
}
const _hoisted_9 = { style: {"margin-top":"32px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_arrow_right = _resolveComponent("ph-arrow-right")!
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roomCodeInput) = $event)),
        class: _normalizeClass(["sv2-room-input", { 'sv2-room-input--branded': _ctx.isValidCode }]),
        placeholder: "Enter Room Code",
        autocomplete: "off",
        spellcheck: "false",
        disabled: _ctx.connecting
      }, null, 10, _hoisted_5), [
        [_vModelText, _ctx.roomCodeInput]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "sv2-btn-primary",
        type: "button",
        style: _normalizeStyle(_ctx.isValidCode ? { background: _ctx.brandPurple } : undefined),
        disabled: !_ctx.form.roomCode.trim() || _ctx.connecting,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleConnect && _ctx.handleConnect(...args)))
      }, [
        (_ctx.connecting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.connecting ? 'Connecting…' : 'Connect') + " ", 1),
        (!_ctx.connecting)
          ? (_openBlock(), _createBlock(_component_ph_arrow_right, {
              key: 1,
              size: 16,
              weight: "bold"
            }))
          : _createCommentVNode("", true)
      ], 12, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "sv2-btn-back",
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('back')))
      }, [
        _createVNode(_component_ph_arrow_left, {
          size: 14,
          weight: "bold"
        }),
        _createTextVNode(" Back ")
      ])
    ])
  ]))
}